var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FieldErrorsView',{staticClass:"input-box",attrs:{"error-fields":_vm.errorFields,"error-box":_vm.errorBox}},[(_vm.title)?_c('h4',[_c('label',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._t("right")],2)]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }